import React, { useEffect, useState } from "react";
import moment from "moment";

// Libraries
import { motion } from "framer-motion";
import {
  RULE_1,
  RULE_2,
  RULE_3,
  RULE_4,
  RULE_5,
  RULE_6,
  RULE_7,
  RULE_8,
  RULE_9,
  RULE_10,
} from "../../mockdata";

import {
  TOTAL_LEVEL,
  STARTING_LEVEL,
  STARTING_TIME,
  TIME_BONUS_PER_LEVEL,
  LIVES_BONUS_PER_LEVEL,
  INITIAL_LIVES,
} from "../../constants/GameConstants";

import { storage } from "../../utilities/storage";

// SCSS
import "./Home.scss";
import { backgroundMusicStart } from "../../utilities/sounds";

const LEVEL_RULE_HASH_MAP = {
  RULE_1,
  RULE_2,
  RULE_3,
  RULE_4,
  RULE_5,
  RULE_6,
  RULE_7,
  RULE_8,
  RULE_9,
  RULE_10,
};

export default function Home(props) {
  let audio = new Audio("/btn-click-sound.mp3");

  const [timeTaken, setTimeTaken] = useState(0);

  const [newMinute, setNewMinute] = useState(STARTING_TIME.minute);
  const [newSeconds, setNewSeconds] = useState(STARTING_TIME.second);
  const [newLevel, setNewLevel] = useState(STARTING_LEVEL);
  const [newLives, setNewLives] = useState(INITIAL_LIVES);

  const metadata = props.location.state;

  useEffect(() => {
    const gameData = storage.get.levelData();
    if (!metadata && gameData && gameData?.levelData?.length) {
      const { totalIncorrectMoves, totalLevelCleared, totalTimeTaken } = gameData;
      const livesRemaining = INITIAL_LIVES - totalIncorrectMoves;
      setNewLives(livesRemaining);
      setNewLevel(totalLevelCleared + 1);
      const minutesRemaining = STARTING_TIME.minute - (Math.floor((totalTimeTaken || 0) / 60));
      const secondsRemaining = STARTING_TIME.second - (Math.floor((totalTimeTaken || 0) % 60));
      setNewMinute(minutesRemaining);
      setNewSeconds(secondsRemaining);
      if (totalIncorrectMoves === 5) {
        props.history.push("/game-over");
      }
    }

    if (metadata && metadata.level) {
      setNewLevel(metadata.level + 1);
    }

    if (metadata && metadata.timePerLevel && metadata.level) {
      let levelStartTime = moment(
        metadata.timePerLevel["level_" + metadata.level].start
      );
      let currentTimestamp = moment();

      let diff = currentTimestamp.diff(levelStartTime, "seconds");
      setTimeTaken(diff);
    }

    if (metadata && metadata.wasFlawlessFinish === true) {
      setNewLives(metadata.lives + LIVES_BONUS_PER_LEVEL);
      if (metadata.time.second + TIME_BONUS_PER_LEVEL > 60) {
        setNewMinute(metadata.time.minute + 1);
        setNewSeconds(metadata.time.second + TIME_BONUS_PER_LEVEL - 60);
      } else {
        setNewMinute(metadata.time.minute);
        setNewSeconds(metadata.time.second + TIME_BONUS_PER_LEVEL);
      }
    } else if (metadata && metadata.wasFlawlessFinish === false) {
      setNewLives(metadata.lives);
    }
  }, []);

  useEffect(() => {
    console.log("=-=-=-=-=-=-=-");
    console.log(newLives);
  }, [newLives]);

  return (
    <div className="view-home">
      <div className="view-home__main-container">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
            alignItems: "center",
            height: "100vh",
          }}
        >
          {/*{metadata && metadata.timePerLevel && (*/}
          {/*  <motion.div*/}
          {/*    className="view-home__level-container"*/}
          {/*    initial={{ opacity: 0 }}*/}
          {/*    animate={{ opacity: 1 }}*/}
          {/*    transition={{*/}
          {/*      duration: 1,*/}
          {/*      delay: 1,*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    <p className="view-home__level-container--level-text">*/}
          {/*      Level Complete*/}
          {/*    </p>*/}
          {/*    <p className="view-home__level-container--title">*/}
          {/*      Level Finished in {timeTaken} sec*/}
          {/*    </p>*/}
          {/*  </motion.div>*/}
          {/*)}*/}

          {/* {metadata && metadata.resultParams && metadata.wasFlawlessFinish && (
            <motion.div
              className="view-home__level-container"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 1,
                delay: 1,
              }}
            >
              <p className="view-home__level-container--level-text">
                FLAWLESS FINISH
              </p>
              <p className="view-home__level-container--title">
                {TIME_BONUS_PER_LEVEL} seconds added to remaining time and{" "}
                {LIVES_BONUS_PER_LEVEL} extra life
              </p>
            </motion.div>
          )} */}

          <motion.div
            className="view-home__level-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 1,
              delay: 1,
            }}
          >
            <p className="view-home__level-container--level-text">
              Rule {newLevel}
            </p>
            <p className="view-home__level-container--title">
              {LEVEL_RULE_HASH_MAP["RULE_" + newLevel].title}
            </p>
            <div
              className="view-home__level-container--button"
              onClick={() => {
                props.history.push("/game", {
                  level: newLevel,
                  time: {
                    minute: newMinute,
                    second: newSeconds,
                  },
                  lives: newLives,
                })
                if (newLevel === STARTING_LEVEL) {
                  localStorage.setItem("playMusic", JSON.stringify(false))
                }
              }
              }
            >
              START
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
